/* eslint-disable @typescript-eslint/no-unused-vars */
import { FlexContainer, Icon, IconName, Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import {
  detailsCategory,
  detailsTranslations,
} from '../../../state/model/operations';
import { StyledDetailError } from './Styles';

const getIcon = (message: string, result: string): IconName => {
  if (message.includes(detailsCategory.geographicOrigin)) {
    return 'Globe';
  } else if (message.includes(detailsCategory.ageEstimation)) {
    return 'Person';
  } else if (message.includes(detailsCategory.gender)) {
    if (result.toLowerCase().includes('female')) {
      return 'GenderFemale';
    } else if (result.toLowerCase().includes('male')) {
      return 'GenderMale';
    }
    return 'GenderNeuter';
  } else if (message.includes(detailsCategory.facialPose)) {
    return 'UserSwitch';
  } else if (message.includes(detailsCategory.facialQuality)) {
    if (result.toLowerCase().includes('none')) {
      return 'MinusCircle';
    } else if (
      result.toLowerCase().includes('bad') ||
      result.toLowerCase().includes('regular')
    ) {
      return 'XCircle';
    }
    return 'CheckCircle';
  } else if (message.includes(detailsCategory.glasses)) {
    return 'Eyeglasses';
  } else if (message.includes(detailsCategory.lipsState)) {
    return 'SmileyBlank';
  } else if (message.includes(detailsCategory.artwork)) {
    return 'UserRectangle';
  } else if (message.includes(detailsCategory.emotion)) {
    return 'MaskHappy';
  } else {
    return 'UserRectangle';
  }
};

const getTexts = (name: detailsCategory): string => detailsTranslations[name];

type Props = {
  name: string;
  result: string;
};

export const DetailFacial = ({ name, result }: Props) => {
  const { t } = useTranslation();

  return (
    <StyledDetailError columnGap="0.8">
      <Icon
        iconName={getIcon(name, result)}
        size="24"
        color="primary400"
        weight="light"
      />
      <FlexContainer rowGap="0.8" flexDirection="column">
        <Label fontSize="14" semibold color="primary400">
          {t(getTexts(name as detailsCategory))}
        </Label>
        {result && (
          <Label fontSize="12">
            {name.includes(detailsCategory.ageEstimation)
              ? `${result} ${t('years old')}`
              : t(result)}
          </Label>
        )}
      </FlexContainer>
    </StyledDetailError>
  );
};
